import { NoticeBox } from '@factorialco/deprecated-design-system'
import moment from 'moment'

import { observer } from 'mobx-react'

import { dateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { terminationReasonTranslation } from 'modules/bookkeepers/lib/dynamicTranslations'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
}

const TerminationBanner = ({ employee }: Props) => {
  if (!employee.terminationDate || !employee.policy.can('terminateEmployee')) {
    return null
  }

  const date = dateToString(moment(employee.attributes.terminated_on), 'ui')
  const terminationTypeDescription = employee.attributes.termination_type_description
    ? ` - ${employee.attributes.termination_type_description}`
    : employee.attributes.termination_reason_type
    ? ` - ${terminationReasonTranslation(employee.attributes.termination_reason_type)}`
    : ''

  let message = i18n.t('employees.terminating_banner', {
    date: date,
  })
  let tooltipLabel = i18n.t('employees.terminating_tooltip', {
    date: date,
  })

  if (employee.isTerminated) {
    message = i18n.t('employees.terminated_banner', {
      date,
    })
    tooltipLabel = i18n.t('employees.terminated_tooltip', {
      date,
    })
  }

  return (
    <NoticeBox
      message={message + terminationTypeDescription}
      justifyContent="center"
      tooltipLabel={tooltipLabel}
    />
  )
}

export default observer(TerminationBanner)
